(function () {
  'use strict';

  /*
    Shared mobile image swipe for all RX collection cards.

    Used by:
    - Prescription Sunglasses
    - Eyeglasses
    - Readers
    - Blue Light
  */

  if (window.__sunhaukRxMobileCardSwipeV2Loaded) {
    return;
  }

  window.__sunhaukRxMobileCardSwipeV2Loaded = true;

  var state = {
    activeSlider: null,
    inputSource: null,

    startX: 0,
    startY: 0,
    currentX: 0,
    currentY: 0,

    dragging: false,
    didSwipe: false,
    blockClickUntil: 0
  };

  function isMobile() {
    return window.matchMedia('(max-width: 749px)').matches;
  }

  function getSliders() {
    return Array.prototype.slice.call(
      document.querySelectorAll(
        '.rx-presc-card.sunhauk-card [data-sunhauk-mobile-card-slider]'
      )
    );
  }

  function setSlide(slider, index) {
    if (!slider) return;

    var safeIndex = index === 1 ? 1 : 0;
    var dots = slider.querySelectorAll('[data-mobile-card-dot]');

    slider.classList.toggle(
      'is-second-active',
      safeIndex === 1
    );

    slider.dataset.mobileCardIndex = String(safeIndex);

    dots.forEach(function (dot, dotIndex) {
      var isActive = dotIndex === safeIndex;

      dot.classList.toggle('is-active', isActive);

      dot.setAttribute(
        'aria-pressed',
        isActive ? 'true' : 'false'
      );
    });
  }

  function prepareSliders(scope) {
    var root = scope || document;

    var sliders = root.querySelectorAll(
      '.rx-presc-card.sunhauk-card [data-sunhauk-mobile-card-slider]'
    );

    sliders.forEach(function (slider) {
      var currentIndex = parseInt(
        slider.dataset.mobileCardIndex,
        10
      );

      if (currentIndex !== 1) {
        currentIndex = 0;
      }

      setSlide(slider, currentIndex);
    });

    /*
      Lets us verify that this exact updated script loaded.
    */
    document.documentElement.dataset.sunhaukRxMobileSwipe = 'v2-ready';
  }

  function findSliderFromTarget(target) {
    if (!target || typeof target.closest !== 'function') {
      return null;
    }

    var slider = target.closest(
      '[data-sunhauk-mobile-card-slider]'
    );

    if (
      slider &&
      slider.closest('.rx-presc-card.sunhauk-card')
    ) {
      return slider;
    }

    return null;
  }

  function findSliderAtPoint(x, y) {
    var sliders = getSliders();

    for (var i = 0; i < sliders.length; i++) {
      var slider = sliders[i];
      var rect = slider.getBoundingClientRect();

      if (
        rect.width > 0 &&
        rect.height > 0 &&
        x >= rect.left &&
        x <= rect.right &&
        y >= rect.top &&
        y <= rect.bottom
      ) {
        return slider;
      }
    }

    return null;
  }

  function resetActiveDrag() {
    if (state.activeSlider) {
      state.activeSlider.classList.remove('is-touching');
    }

    state.activeSlider = null;
    state.inputSource = null;
    state.dragging = false;
  }

  function startDrag(x, y, target, inputSource) {
    if (!isMobile()) return;

    prepareSliders(document);

    /*
      On many mobile browsers, pointerdown fires before touchstart.

      The touch event must be allowed to take control because it is
      the reliable gesture stream on the affected RX collection.
    */
    if (
      inputSource === 'touch' &&
      state.dragging &&
      state.inputSource === 'pointer'
    ) {
      resetActiveDrag();
    } else if (state.dragging) {
      return;
    }

    var slider =
      findSliderFromTarget(target) ||
      findSliderAtPoint(x, y);

    if (!slider) return;

    state.activeSlider = slider;
    state.inputSource = inputSource;

    state.startX = x;
    state.startY = y;
    state.currentX = x;
    state.currentY = y;

    state.dragging = true;
    state.didSwipe = false;

    slider.classList.add('is-touching');
  }

  function moveDrag(event, x, y, inputSource) {
    if (!isMobile()) return;
    if (!state.dragging || !state.activeSlider) return;

    /*
      Ignore events from the other event family once a drag
      source has been selected.
    */
    if (state.inputSource !== inputSource) return;

    state.currentX = x;
    state.currentY = y;

    var deltaX = state.currentX - state.startX;
    var deltaY = state.currentY - state.startY;

    /*
      Only capture a clearly horizontal gesture.
      Vertical page scrolling remains normal.
    */
    if (
      Math.abs(deltaX) > 6 &&
      Math.abs(deltaX) > Math.abs(deltaY)
    ) {
      state.didSwipe = true;

      if (event && event.cancelable) {
        event.preventDefault();
      }
    }
  }

  function finishDrag(inputSource, allowSlideChange) {
    if (!isMobile()) return;
    if (!state.dragging || !state.activeSlider) return;
    if (state.inputSource !== inputSource) return;

    var slider = state.activeSlider;

    var deltaX = state.currentX - state.startX;
    var deltaY = state.currentY - state.startY;

    resetActiveDrag();

    if (!allowSlideChange) {
      return;
    }

    if (
      Math.abs(deltaX) > 22 &&
      Math.abs(deltaX) > Math.abs(deltaY)
    ) {
      if (deltaX < 0) {
        setSlide(slider, 1);
      } else {
        setSlide(slider, 0);
      }

      /*
        Stop the card link from opening immediately after swipe.
      */
      state.blockClickUntil = Date.now() + 450;
    }
  }

  /*
    ============================================================
    Pointer events

    Keep these for:
    - Android/modern browsers
    - Desktop mobile preview
    - Mouse testing
    - Pen input
    ============================================================
  */

  document.addEventListener(
    'pointerdown',
    function (event) {
      startDrag(
        event.clientX,
        event.clientY,
        event.target,
        'pointer'
      );
    },
    true
  );

  document.addEventListener(
    'pointermove',
    function (event) {
      moveDrag(
        event,
        event.clientX,
        event.clientY,
        'pointer'
      );
    },
    {
      capture: true,
      passive: false
    }
  );

  document.addEventListener(
    'pointerup',
    function () {
      finishDrag('pointer', true);
    },
    true
  );

  document.addEventListener(
    'pointercancel',
    function () {
      finishDrag('pointer', false);
    },
    true
  );

  /*
    ============================================================
    Touch events

    These are deliberately registered even when PointerEvent
    exists. This is the important correction.
    ============================================================
  */

  document.addEventListener(
    'touchstart',
    function (event) {
      if (!event.touches || !event.touches.length) {
        return;
      }

      var touch = event.touches[0];

      startDrag(
        touch.clientX,
        touch.clientY,
        event.target,
        'touch'
      );
    },
    {
      capture: true,
      passive: true
    }
  );

  document.addEventListener(
    'touchmove',
    function (event) {
      if (!event.touches || !event.touches.length) {
        return;
      }

      var touch = event.touches[0];

      moveDrag(
        event,
        touch.clientX,
        touch.clientY,
        'touch'
      );
    },
    {
      capture: true,
      passive: false
    }
  );

  document.addEventListener(
    'touchend',
    function () {
      finishDrag('touch', true);
    },
    true
  );

  document.addEventListener(
    'touchcancel',
    function () {
      finishDrag('touch', false);
    },
    true
  );

  /*
    ============================================================
    Dot controls and accidental-link prevention
    ============================================================
  */

  document.addEventListener(
    'click',
    function (event) {
      var dot =
        event.target &&
        typeof event.target.closest === 'function'
          ? event.target.closest('[data-mobile-card-dot]')
          : null;

      if (dot && isMobile()) {
        var dotSlider = dot.closest(
          '[data-sunhauk-mobile-card-slider]'
        );

        if (
          dotSlider &&
          dotSlider.closest('.rx-presc-card.sunhauk-card')
        ) {
          event.preventDefault();
          event.stopPropagation();

          var index = parseInt(
            dot.getAttribute('data-mobile-card-dot'),
            10
          );

          setSlide(dotSlider, index);

          state.blockClickUntil = Date.now() + 300;
          return;
        }
      }

      if (!isMobile()) return;

      var rxCard =
        event.target &&
        typeof event.target.closest === 'function'
          ? event.target.closest(
              '.rx-presc-card.sunhauk-card'
            )
          : null;

      if (!rxCard) return;

      if (
        state.didSwipe ||
        Date.now() < state.blockClickUntil
      ) {
        event.preventDefault();
        event.stopPropagation();

        state.didSwipe = false;
      }
    },
    true
  );

  function initialize() {
    prepareSliders(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initialize
    );
  } else {
    initialize();
  }

  /*
    Theme customizer section reload.
  */
  document.addEventListener(
    'shopify:section:load',
    function (event) {
      prepareSliders(event.target || document);
    }
  );

  /*
    Filtering and sorting replace the product-grid HTML.
  */
  var observer = new MutationObserver(function (mutations) {
    var needsPreparation = false;

    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (!node || node.nodeType !== 1) return;

        if (
          node.matches &&
          (
            node.matches('.rx-presc-card.sunhauk-card') ||
            node.matches(
              '[data-sunhauk-mobile-card-slider]'
            )
          )
        ) {
          needsPreparation = true;
          return;
        }

        if (
          node.querySelector &&
          node.querySelector(
            '[data-sunhauk-mobile-card-slider]'
          )
        ) {
          needsPreparation = true;
        }
      });
    });

    if (needsPreparation) {
      window.requestAnimationFrame(function () {
        prepareSliders(document);
      });
    }
  });

  if (document.body) {
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }
})();